var _effectorFileName = "/src/page-content/speaking-clubs/ui.tsx";
import { useRouter } from 'next/router';
import { WebPageJsonLd } from 'next-seo';
import { MainSpeakingClubs } from '@/page-content/speaking-clubs/components/main-speaking-clubs';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
import { SpeakingClubHost } from './components/speaking-club-host';
import { ThemesSpeakingClubs } from './components/themes-speaking-clubs';
export const SpeakingClubsPage = () => {
  const router = useRouter();
  return <>
      <PageSeo title="Разговорный клуб" description={`Разговорный клуб – это лучший способ попрактиковать английский с коллегами из смежных сфер и весело провести время. ${APP_TITLE} – деловой английский для работы.`} />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} name={`${APP_TITLE} - Разговорный клуб`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} description={`Разговорный клуб – это лучший способ попрактиковать английский с коллегами из смежных сфер и весело провести время. ${APP_TITLE} – деловой английский для работы.`} about={['английский', 'онлайн', 'консультации', 'разговорный клуб']} />

      <MainSpeakingClubs />

      <SpeakingClubHost />

      <ThemesSpeakingClubs />

      <CallToAction withForm header="Записаться" description="Приходите к нам на speaking club прокачать английский и познакомиться с единомышленниками из вашей сферы" />
    </>;
};
SpeakingClubsPage.Layout = MainLayout;